import ProgressBar from '@space-core/components/progressBar'
import clsx from 'clsx'

import styled from 'styled-components'

import type { CardProps } from './types'

import DefaultBaseCard from '../base/default'
import { CardOrientation } from '../base/enum'

const Description = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

const ProgressCardDefault = ({ product, items, orientation }: CardProps) => {
  const contentContainerClass = clsx(
    '_d-flex _flex-column _justify-content-center _align-items-start _h-full',
    {
      '_p-0 _pt-4': orientation === CardOrientation.VERTICAL
    }
  )

  return (
    <DefaultBaseCard
      items={items}
      icon={product.icon}
      iconSize={product.iconSize}
      iconRounded={product.iconRounded}
      tag={product.tag}
      orientation={orientation}
      coverImage={product.coverImage}>
      <div className={contentContainerClass}>
        <ProgressBar
          className='hot-progress--sm _w-full'
          progressValue={product.completedPercentage}
          data-test='progress-bar'
        />
        {product.pageName && (
          <p
            data-test='progress-page-name'
            className='_font-14 _text-gray-900 _mb-0 _mt-4 _text-left'>
            {product.pageName}
          </p>
        )}
        <h3 className='_font-18 _text-gray-900 _font-weight-bold _m-0 _mt-1 _py-1 _text-left'>
          {product.name}
        </h3>

        {orientation === CardOrientation.HORIZONTAL && (
          <Description
            className='_font-14 _text-left _text-gray-600 _m-0 _mt-1 _w-full'
            data-test='progress-description'>
            {product.description}
          </Description>
        )}
      </div>
    </DefaultBaseCard>
  )
}

export default ProgressCardDefault
